import gql from 'graphql-tag';

export const getContactListHistories = gql`
  query getContactListHistories($id: String) {
    getContactListHistories(id: $id) {
      updater
      updatedAt
    }
  }
`;
